import './server-error.scss'

const ServerError = () => {
  return <section className="videos-error">Something went wrong.</section>
}

export default ServerError
